export default __webpack_public_path__ + "static/media/2.d1731a73.png";